<template>
  <div></div>
</template>

<script>
import UserService from '@/services/user';
import CookieService from '@/services/cookie';
import TokenService from '@/services/token';
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'Dashboard',
  setup() {
    const router = useRouter();

    onBeforeMount(async () => {
      const response = await UserService.getProfile();

      // if (!response.data.username) {
      //   router.push('/finish-setup');
      //   return;
      // }

      let returnUrl;
      const referrer = CookieService.getCookie('redirect');
      console.log('REFERRER', referrer);
      const state = CookieService.getCookie('state');
      console.log('State', state);
      const parsedState = state ? JSON.parse(state) : null;

      if (referrer) {
        returnUrl = new URL(referrer);
      } else {
        returnUrl = 'https://home.casago.com';
      }

      if (parsedState && parsedState.is_interstitial) {
        const accessToken = TokenService.getToken();
        parsedState.access_token = accessToken;
      }

      if (parsedState && Object.keys(parsedState).length) {
        returnUrl.searchParams.set('state', encodeURIComponent(JSON.stringify(parsedState)));
        console.log(returnUrl);
      }

      CookieService.removeCookie('redirect');
      CookieService.removeCookie('client_id');
      CookieService.removeCookie('state');

      window.location.href = returnUrl.href;
    });
  },
};
</script>
